<template>
  <div class="page">
    <div class="bg-content padding15 tp-root">
      <!-- Header -->
      <header class="tp-header">
        <div>
          <nav class="tp-breadcrumb">
            <span>标签池管理中心</span>
            <span class="tp-breadcrumb__sep">/</span>
            <span class="tp-breadcrumb__current">三级标签池集成管理</span>
          </nav>
          <h1 class="tp-header__title">三级标签池集成中心</h1>
        </div>
        <div class="tp-header__right">
          <div class="tp-header__stat">
            <div class="tp-header__stat-label">{{ statLabel }}</div>
            <div class="tp-header__stat-value">
              {{ statNumber }} <span class="tp-header__stat-unit">{{ statUnit }}</span>
            </div>
          </div>
          <div class="tp-header__divider"></div>
          <el-badge is-dot>
            <el-button icon="el-icon-bell" circle></el-button>
          </el-badge>
        </div>
      </header>

      <div class="tp-body">
        <!-- Diagram -->
        <section class="tp-diagram">
          <div class="tp-diagram__nodes">
            <!-- Node: General -->
            <div class="tp-node" :class="{ 'tp-node--active': activeTab === 'general' }" @click="switchTab('general')">
              <div class="tp-node__inner">
                <div class="tp-node__icon tp-node__icon--blue"><i class="el-icon-share"></i></div>
                <div>
                  <div class="tp-node__title">通用标签池</div>
                  <span class="tp-node__badge tp-node__badge--blue">元数据源头</span>
                </div>
              </div>
              <p class="tp-node__desc">所有标签的根源地，支持按业务类型定义并共享至全部公司。</p>
            </div>
            <!-- Arrow 1 -->
            <div class="tp-arrow">
              <svg fill="none" height="24" viewBox="0 0 60 24" width="60">
                <path d="M0 12H52" stroke="#CBD5E1" stroke-linecap="round" stroke-width="2"></path>
                <path class="tp-arrow__flow" :class="{ 'tp-arrow__flow--on': activeTab !== 'general' }" d="M0 12H52" stroke="#3B82F6" stroke-linecap="round" stroke-width="2"></path>
                <path d="M50 8L54 12L50 16" stroke="#3B82F6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
              </svg>
            </div>
            <!-- Node: Company -->
            <div class="tp-node" :class="{ 'tp-node--active': activeTab === 'company' }" @click="switchTab('company')">
              <div class="tp-node__inner">
                <div class="tp-node__icon tp-node__icon--green"><i class="el-icon-office-building"></i></div>
                <div>
                  <div class="tp-node__title">公司标签池</div>
                  <span class="tp-node__badge tp-node__badge--green">引用 + 自有</span>
                </div>
              </div>
              <p class="tp-node__desc">根据公司业务属性从通用池选用，并支持创建公司私有标签。</p>
            </div>
            <!-- Arrow 2 -->
            <div class="tp-arrow">
              <svg fill="none" height="24" viewBox="0 0 60 24" width="60">
                <path d="M0 12H52" stroke="#CBD5E1" stroke-linecap="round" stroke-width="2"></path>
                <path class="tp-arrow__flow" :class="{ 'tp-arrow__flow--on': activeTab === 'business' || activeTab === 'leaderboard' }" d="M0 12H52" stroke="#10B981" stroke-linecap="round" stroke-width="2"></path>
                <path d="M50 8L54 12L50 16" :stroke="activeTab === 'business' || activeTab === 'leaderboard' ? '#10B981' : '#CBD5E1'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
              </svg>
            </div>
            <!-- Node: Business -->
            <div class="tp-node" :class="{ 'tp-node--active': activeTab === 'business' }" @click="switchTab('business')">
              <div class="tp-node__inner">
                <div class="tp-node__icon tp-node__icon--purple"><i class="el-icon-folder-opened"></i></div>
                <div>
                  <div class="tp-node__title">业务标签池</div>
                  <span class="tp-node__badge tp-node__badge--purple">归属应用层</span>
                </div>
              </div>
              <p class="tp-node__desc">精准对接具体业务线，仅可从归属公司池引用，不可自行新增。</p>
            </div>
            <!-- Arrow 3 -->
            <div class="tp-arrow">
              <svg fill="none" height="24" viewBox="0 0 60 24" width="60">
                <path d="M0 12H52" stroke="#CBD5E1" stroke-linecap="round" stroke-width="2"></path>
                <path class="tp-arrow__flow" :class="{ 'tp-arrow__flow--on': activeTab === 'leaderboard' }" d="M0 12H52" stroke="#F59E0B" stroke-linecap="round" stroke-width="2"></path>
                <path d="M50 8L54 12L50 16" :stroke="activeTab === 'leaderboard' ? '#F59E0B' : '#CBD5E1'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
              </svg>
            </div>
            <!-- Node: Leaderboard -->
            <div class="tp-node" :class="{ 'tp-node--active': activeTab === 'leaderboard' }" @click="switchTab('leaderboard')">
              <div class="tp-node__inner">
                <div class="tp-node__icon tp-node__icon--amber"><i class="el-icon-data-line"></i></div>
                <div>
                  <div class="tp-node__title">排行榜</div>
                  <span class="tp-node__badge tp-node__badge--amber">数据透视</span>
                </div>
              </div>
              <p class="tp-node__desc">全维度标签触发统计，多级筛选透视，实时掌握业务热度趋势。</p>
            </div>
          </div>
          <div class="tp-diagram__decor"></div>
        </section>

        <!-- Custom Tab Bar -->
        <div class="tp-tab-bar">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            class="tp-tab-btn"
            :class="{ 'tp-tab-btn--active': activeTab === tab.key }"
            :style="activeTab === tab.key ? { color: tab.activeColor } : {}"
            @click="switchTab(tab.key)"
          >
            <i :class="tab.icon"></i>
            <span>{{ tab.label }}</span>
            <span class="tp-tab-btn__count">{{ tab.count }}</span>
          </button>
          <div
            class="tp-tab-indicator"
            :style="indicatorStyle"
          ></div>
        </div>

        <!-- Tab Content -->
        <div class="tp-content">
          <div v-show="activeTab === 'general'">
            <general-pool
              ref="generalPool"
              :tags="tagData.general"
              :company-list="companyOptions"
              :active="activeTab === 'general'"
              :case-status-option="caseStatusOption"
              :contact-status-option="contactStatusOption"
              @refresh="fetchGeneralTags"
            ></general-pool>
          </div>
          <div v-show="activeTab === 'company'">
            <company-pool
              ref="companyPool"
              :company-tags="tagData.company"
              :company-list="companyOptions"
              :strategy-config="strategyConfig"
              :active="activeTab === 'company'"
              :saved-company="selectedCompany"
              @company-change="onCompanyChange"
              @company-change-type="onCompanyChangeType"
              :case-status-option="caseStatusOption"
              :contact-status-option="contactStatusOption"
            ></company-pool>
          </div>
          <div v-show="activeTab === 'business'">
            <business-pool
              ref="businessPool"
              :tags="tagData.business"
              :company-list="companyOptions"
              :active="activeTab === 'business'"
              :saved-company="selectedCompanyBusiness"
              @company-change-business="onCompanyChangeBusiness"
              @company-change-business-type="onCompanyChangeBusinessType"
              @group-change-business="onGroupChangeBusiness"
              :case-status-option="caseStatusOption"
              :contact-status-option="contactStatusOption"
              @biz-open-count-change="bizOpenGroupCount = $event"
            ></business-pool>
          </div>
          <div v-show="activeTab === 'leaderboard'">
            <leaderboard
              ref="leaderboard"
              :leaderboard-data="leaderboardData"
              :company-list="companyOptions"
              :loading="boardLoading"
              @filter-change="onBoardFilterChange"
            ></leaderboard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralPool from './general-pool';
import CompanyPool from './company-pool';
import BusinessPool from './business-pool';
import { getBusinessTypeLabel } from '../../../utils/business-type';
import Leaderboard from './leaderboard';

export default {
  name: 'TagPools',
  components: { GeneralPool, CompanyPool, BusinessPool, Leaderboard },
  data() {
    return {
      activeTab: 'general',
      caseStatusOption: [],
      contactStatusOption: [],
      defaultSort: {
        order: 'priority',
        sort: 'asc'
      },
      tagData: {
        general: [],
        company: {
          general: [],
          own: []
        },
        business: []
      },
      // 策略配置只作为本地变更记录：key 是标签 id，value 是 { 策略组id: 是否已配置 }。
      // 初始不预置数据，展示以接口返回的 strategyConfiguredCount 为准
      strategyConfig: {},
      companyOptions: [],
      selectedCompany: null,
      selectedCompanyType: '',
      selectedCompanyBusiness: null,
      selectedCompanyBusinessType: '',
      // 业务标签池中 isGroupLabelOpen 为 true 的策略组个数（由 business-pool 上报）
      bizOpenGroupCount: 0,
      groupReq: {
        companyId: ''
      },
      groupBusinessId: null,
      groupBusiness: {
        groupOption: []
      },
      // 排行榜筛选条件
      boardCompanyId: null,
      boardGroupId: null,
      boardDays: 0,
      boardLoading: false,
      // 排行榜是否已首次拉取：只在首次进入排行榜时才自动请求
      boardFetched: false,
      // 排行榜数据：/scene/rankingList 返回 { rowList, groupCount }
      leaderboardData: {
        rowList: [],
        groupCount: 0
      }
    };
  },
  computed: {
    statLabel() {
      const map = { general: '通用标签池统计', company: '入驻公司统计', business: '活跃业务池统计', leaderboard: '标签触发排行榜' };
      return map[this.activeTab] || '通用标签池统计';
    },
    statNumber() {
      const value = this.statCounts[this.activeTab];
      return Number(value || 0).toLocaleString();
    },
    // 各标签页的统计数字（头部统计与 tab 角标共用）：
    // 通用池取标签总数、公司池取公司数、业务池取已开启标签的业务池数、排行榜取触发次数总和
    statCounts() {
      return {
        general: (this.tagData.general || []).length,
        company: (this.companyOptions || []).length,
        business: this.bizOpenGroupCount,
        leaderboard: (this.leaderboardData.rowList || [])
          .reduce((sum, item) => sum + (Number(item.count) || 0), 0)
      };
    },
    // tab 角标文案随数据实时变化
    tabs() {
      const counts = this.statCounts;
      return [
        { key: 'general', label: '通用标签池', icon: 'el-icon-share', count: `${counts.general} 个标签`, activeColor: '#3B82F6' },
        { key: 'company', label: '公司标签池', icon: 'el-icon-office-building', count: `${counts.company} 家入驻公司`, activeColor: '#10B981' },
        { key: 'business', label: '业务标签池', icon: 'el-icon-folder-opened', count: `${counts.business} 个业务池`, activeColor: '#8B5CF6' },
        { key: 'leaderboard', label: '排行榜', icon: 'el-icon-data-line', count: `${counts.leaderboard} 次触发`, activeColor: '#F59E0B' }
      ];
    },
    statUnit() {
      const map = { general: '个标签', company: '家机构', business: '个应用', leaderboard: '次触发' };
      return map[this.activeTab] || '个标签';
    },
    indicatorStyle() {
      const idx = this.tabs.findIndex(t => t.key === this.activeTab);
      const lefts = [0, 100, 232, 340];
      const widths = [120, 120, 120, 120];
      const colors = ['#3B82F6', '#10B981', '#8B5CF6', '#F59E0B'];
      return {
        left: `${lefts[idx] || 0}px`,
        width: `${widths[idx] || 120}px`,
        background: colors[idx] || '#3B82F6'
      };
    }
  },
  watch: {
    // 仅在首次进入排行榜时按当前筛选条件拉取数据
    // 之后修改筛选条件不会自动请求，需点击「查询」按钮（onBoardFilterChange）
    activeTab(tab) {
      if (tab === 'leaderboard' && !this.boardFetched) {
        this.boardFetched = true;
        this.fetchBoardTags();
      }
    }
  },
  mounted() {
    this.fetchGeneralTags();
    this.getCaseStatusParam();
    this.getContactStatusParam();
    this.getCompanyList();
  },
  methods: {
    // 返回标签页对应池组件的 ref 名（仅公司池、业务池支持排序模式）
    sortPoolRefName(tabKey) {
      if (tabKey === 'company') return 'companyPool';
      if (tabKey === 'business') return 'businessPool';
      return '';
    },
    // 切换标签页：当前池开启了排序模式时，确认后才允许离开（离开即恢复排序）
    switchTab(key) {
      if (key === this.activeTab) return;
      const refName = this.sortPoolRefName(this.activeTab);
      const pool = refName ? this.$refs[refName] : null;
      if (!pool || !pool.sortMode) {
        this.activeTab = key;
        return;
      }
      this.$confirm('排序模式已开启，离开将恢复排序，是否确认离开？', '提示', {
        confirmButtonText: '确认离开',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 静默退出排序模式，数据由目标标签页自身的进入流程负责刷新
          if (typeof pool.clearSortMode === 'function') pool.clearSortMode();
          this.activeTab = key;
        })
        .catch(() => {});
    },
    getCompanyList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        const list = (res.data || []).filter(item => Number(item.id) !== 0);
        this.companyOptions = list.map(item => ({
          ...item,
          type: getBusinessTypeLabel(item.businessType)
        }));
      }).catch(() => {
        this.companyOptions = [];
      });
    },
    getCaseStatusParam() {
      this.$ajax({
        url: '/dict/getCaseStatusParam',
        method: 'GET'
      }).then((res) => {
        this.caseStatusOption = res.data || [];
      });
    },
    getContactStatusParam() {
      this.$ajax({
        url: '/dict/getContactStatusParam',
        data: { contactStatusType: 'benrendianhuaContactStatus' },
        method: 'POST'
      }).then((res) => {
        this.contactStatusOption = res.data || [];
      });
    },
    fetchGeneralTags(typeFilter = '') {
      this.$ajax({
        url: '/label/list',
        method: 'post',
        data: this.getSearchParam(typeFilter, 0, 0)
      })
        .then((res) => {
          const list = res.data.list || [];
          this.tagData.general = list.map(item => this.normalizeTag(item, 'general'));
        })
        .catch(() => {
          this.tagData.general = [];
        });
    },
    // 公司标签池：按选中的公司 id 查询
    fetchCompanyTags(companyId) {
      if (companyId == null) return;
      this.$ajax({
        url: '/label/list',
        method: 'post',
        data: this.getSearchParam('', companyId, 0)
      })
        .then((res) => {
          const list = (res.data.list || []).map(item => this.normalizeTag(item, 'company'));
          // 按 isCommon 拆分来源：isCommon 为 0/false 视为「公司自有标签」，其余归入「来自通用池」
          this.tagData.company.general = list.filter(item => Number(item.isCommon) !== 0);
          this.tagData.company.own = list.filter(item => Number(item.isCommon) === 0);
        })
        .catch(() => {
          this.tagData.company.general = [];
          this.tagData.company.own = [];
        });
    },
    // 业务标签池：按选中的公司 id 查询
    fetchBusinessTags(companyId, groupId) {
      if (companyId == null) return;
      this.$ajax({
        url: '/label/list',
        method: 'post',
        data: this.getSearchParam('', companyId, groupId)
      })
        .then((res) => {
          const list = res.data.list || [];
          // 接口暂未返回来源字段，先统一归入「来自通用池」；后续后端提供来源字段再拆分
          this.tagData.business = list.map(item => this.normalizeTag(item, 'business'));
        })
        .catch(() => {
          this.tagData.business = [];
        });
    },
    onCompanyChange(company) {
      this.selectedCompany = company;
      this.fetchCompanyTags(company);
    },
    onCompanyChangeType(type) {
      this.selectedCompanyType = type;
    },
    onCompanyChangeBusiness(company) {
      this.selectedCompanyBusiness = company;
    },
    onCompanyChangeBusinessType(type) {
      this.selectedCompanyBusinessType = type;
    },
    onGroupChangeBusiness(group) {
      this.groupBusinessId = group;
      this.fetchBusinessTags(this.selectedCompanyBusiness, group);
    },
    // 排行榜：/scene/rankingList
    // 返回 RobotRankingDTO{ rowList: [{ label, labelCount, labelScore }], groupCount }
    fetchBoardTags() {
      this.boardLoading = true;
      this.$ajax({
        url: '/scene/rankingList',
        method: 'post',
        data: this.getSearchBoardParam(this.boardCompanyId, this.boardGroupId, this.boardDays)
      })
        .then((res) => {
          this.boardLoading = false;
          const data = res.data || {};
          this.leaderboardData = {
            rowList: (data.rowList || []).map(item => this.normalizeBoardRow(item)),
            groupCount: Number(data.groupCount) || 0
          };
        })
        .catch(() => {
          this.boardLoading = false;
          this.leaderboardData = { rowList: [], groupCount: 0 };
        });
    },
    // RobotRankingRowDTO -> 视图结构：
    // label -> tagName，labelCount -> count，labelScore -> change（环比，2位小数、带正负）+ trend（涨跌方向）
    normalizeBoardRow(item) {
      const score = item.labelScore == null ? 0 : Number(item.labelScore);
      let trend = 'flat';
      if (score > 0) {
        trend = 'up';
      } else if (score < 0) {
        trend = 'down';
      }
      return {
        tagName: item.label || '',
        count: Number(item.labelCount) || 0,
        change: score.toFixed(2),
        trend
      };
    },
    onBoardFilterChange({ companyId, groupId, days }) {
      this.boardCompanyId = companyId;
      this.boardGroupId = groupId;
      this.boardDays = days;
      this.fetchBoardTags();
    },
    // 排行榜查询参数：RankingReq（companyId / groupId / days），startTime 由后端按 days 计算，无需下传
    getSearchBoardParam(companyId, groupId, days) {
      return {
        'companyId': companyId,
        'groupId': groupId,
        'days': days,
        'page': 1,
        'limit': 0
      };
    },
    normalizeTag(item, poolType) {
      return {
        ...item,
        id: String(item.id),
        code: item.code || item.labelCode || '',
        type: this.getLabelType(item, poolType),
        desc: item.remark || '',
        parentTagId: item.parentId != null ? String(item.parentId) : null
      };
    },
    getLabelType(tag, poolType) {
      if (poolType === 'company') {
        if (tag.isCommon) {
          return getBusinessTypeLabel(tag.businessType) || '通用类';
        } return this.selectedCompanyType;
      } else if (poolType === 'business') {
        if (tag.isCommon) {
          return getBusinessTypeLabel(tag.businessType) || '通用类';
        } return this.selectedCompanyBusinessType;
      } else if (poolType === 'general') {
        return getBusinessTypeLabel(tag.businessType) || '通用类';
      }
      return '';
    },
    mapLabelStatus(status) {
      if (status === true) {
        return '启用中';
      }
      if (status === false) {
        return '已停用';
      }
      return status || '启用中';
    },
    getSearchParam(typeFilter, companyId, groupId) {
      const req = {
        'companyId': companyId,
        'groupId': groupId,
        'label': null,
        'mainStrategy': null,
        'caseStatusList': null,
        'labelStatus': null,
        'businessType': typeFilter,
        'page': 1,
        'limit': 0,
        'order': this.defaultSort.order,
        'sort': this.defaultSort.sort,
        // 带上该标记，列表项才会返回 strategyConfiguredCount（初始已配置策略组个数）
        'isLabelSetGroup': true
      };
      return req;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../assets/style/variable.less';

.tp-root {
  padding: 0;
}

// Header
.tp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 32px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;

  &__title {
    font-size: 24px;
    font-weight: bold;
    color: #0f172a;
    margin: 2px 0 0;
    letter-spacing: -0.025em;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 24px;
  }

  &__stat {
    text-align: right;
  }

  &__stat-label {
    font-size: 12px;
    color: #64748b;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
  }

  &__stat-value {
    font-size: 20px;
    font-weight: bold;
    color: #0f172a;
  }

  &__stat-unit {
    font-size: 14px;
    font-weight: normal;
    color: #64748b;
  }

  &__divider {
    width: 1px;
    height: 40px;
    background: #e2e8f0;
  }
}

.tp-breadcrumb {
  display: flex;
  font-size: 14px;
  color: #64748b;
  margin-bottom: 4px;

  &__sep {
    margin: 0 8px;
  }

  &__current {
    color: #0f172a;
  }
}

// Body wrapper
.tp-body {
  padding: 32px;
  overflow-y: auto;
  max-height: calc(100vh - 85px);
}

// Diagram
.tp-diagram {
  position: relative;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 24px;
  margin-bottom: 32px;
  overflow: hidden;

  &__nodes {
    display: flex;
    align-items: center;
    gap: 0;
    margin: 0 auto;
    position: relative;
    z-index: 10;
  }

  &__decor {
    position: absolute;
    top: 0;
    right: 0;
    width: 256px;
    height: 256px;
    background: #f8fafc;
    border-radius: 50%;
    margin-right: -128px;
    margin-top: -128px;
    opacity: 0.5;
    z-index: 0;
  }
}

.tp-node {
  flex: 1;
  min-width: 0;
  max-width: 260px;
  padding: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;

  &:hover {
    border-color: #93c5fd;
  }

  &--active {
    transform: scale(1.05);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
    border-color: #3b82f6;
  }

  &__inner {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
  }

  &__icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
    transition: transform 0.2s;

    .tp-node:hover & {
      transform: scale(1.1);
    }

    &--blue { background: #dbeafe; color: #2563eb; }
    &--green { background: #d1fae5; color: #059669; }
    &--purple { background: #ede9fe; color: #7c3aed; }
    &--amber { background: #fef3c7; color: #d97706; }
  }

  &__title {
    font-size: 15px;
    font-weight: bold;
    color: #1e293b;
    line-height: 1.3;
  }

  &__badge {
    font-size: 11px;
    padding: 1px 8px;
    border-radius: 9999px;
    display: inline-block;
    margin-top: 2px;

    &--blue { background: #eff6ff; color: #2563eb; }
    &--green { background: #ecfdf5; color: #059669; }
    &--purple { background: #f5f3ff; color: #7c3aed; }
    &--amber { background: #fffbeb; color: #d97706; }
  }

  &__desc {
    font-size: 12px;
    color: #64748b;
    margin: 0;
    line-height: 1.5;
  }
}

.tp-arrow {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 16px 2px;
  width: 52px;
}

.tp-arrow__flow {
  stroke-dasharray: 10, 10;
  animation: flow 1s linear infinite;
  opacity: 0;

  &--on {
    opacity: 1;
  }
}

@keyframes flow {
  to { stroke-dashoffset: -20; }
}

// Tab Bar
.tp-tab-bar {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  gap: 32px;
  position: relative;
  padding: 0 8px;
  margin-bottom: 0;
}

.tp-tab-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  border: none;
  background: none;
  cursor: pointer;
  color: #94a3b8;
  transition: all 0.3s;
  position: relative;

  i {
    font-size: 18px;
    margin-bottom: 4px;
  }

  span {
    font-weight: bold;
    font-size: 14px;
  }

  &:hover {
    color: #64748b;
  }

  &--active {
    color: #3b82f6;
  }

  &__count {
    font-size: 12px;
    opacity: 0.7;
    font-weight: normal !important;
    margin-top: 2px;
  }
}

.tp-tab-indicator {
  position: absolute;
  bottom: -1px;
  height: 3px;
  border-radius: 9999px 9999px 0 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tp-content {
  padding-top: 24px;
  min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/tagpools/index.vue